import {FormGroup} from "@angular/forms";
import {TYPE} from "../../../shared/types/types";
import {Timezone} from "@syncfusion/ej2-angular-schedule";


//Helper method to convert back any selected time to UTC 0 because we will save it like that in the DB
export function recalculateTimezoneData(calendarEventForm: FormGroup): { startUTC: Date; endUTC: Date; } {
  const start = calendarEventForm.get('onDateStart')?.value;
  const end = calendarEventForm.get('onDateEnd')?.value;

  const timezone = new Timezone();
  const startZone = calendarEventForm.get('startTimeZone')?.value; // e.g., 'Europe/Berlin'
  // const endZone = calendarEventForm.get('endTimeZone')?.value;
  const startUTC = timezone.convert(start, startZone, 'UTC');
  const endUTC = timezone.convert(end, startZone, 'UTC');
  return {startUTC, endUTC};
}


export function buildRecurrenceString(rule: TYPE.RecurrenceRule): string {
  if (!rule || rule.repeatType === 'never') return '';

  const parts: string[] = [];

  parts.push(`FREQ=${rule.repeatType.toUpperCase()}`);
  parts.push(`INTERVAL=${rule.repeatEvery || 1}`);

  if (rule.repeatEndType === 'count' && rule.repeatDaysCount) {
    parts.push(`COUNT=${rule.repeatDaysCount}`);
  } else if (rule.repeatEndType === 'until' && rule.repeatDaysUntil) {
    const until = new Date(rule.repeatDaysUntil);
    const utc = until.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    parts.push(`UNTIL=${utc}`);
  }

  if (rule.repeatType === 'weekly' && rule.repeatOn?.length) {
    parts.push(`BYDAY=${rule.repeatOn.join(',')}`);
  }

  if (rule.repeatType === 'monthly') {
    if (rule.monthlyRepeatMode === true) {
      parts.push(`BYMONTHDAY=${rule.monthlyRepeatDay}`);
    } else {
      parts.push(`BYSETPOS=${rule.monthlyOrdinal}`);
      parts.push(`BYDAY=${rule.monthlyWeekday}`);
    }
  }

  if (rule.repeatType === 'yearly') {
    parts.push(`BYMONTH=${rule.repeatMonth}`);
    if (rule.monthlyRepeatMode === true) {
      parts.push(`BYMONTHDAY=${rule.monthlyRepeatDay}`);
    } else {
      parts.push(`BYSETPOS=${rule.monthlyOrdinal}`);
      parts.push(`BYDAY=${rule.monthlyWeekday}`);
    }
  }

  return parts.join(';');
}
